import clsx from 'clsx';
import { forwardRef } from 'react';

import * as styles from './Table.css';
import { VirtuosoTableProps } from './VirtuosoTableContext';

export const VirtuosoTable = forwardRef<
  HTMLTableElement,
  VirtuosoTableProps<any>
>(function VirtuosoTable({ children, context, ...rest }, ref) {
  const baseClass = context
    ? styles.tableVariants[context.variant ?? 'normal']
    : styles.tableVariants.normal;

  const mergedClassName = clsx(baseClass);

  return (
    <table ref={ref} className={mergedClassName} {...rest}>
      {children}
    </table>
  );
});
